import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Monitor, Smartphone, MapPin, Trash2, ShieldOff } from 'lucide-react';

function parseDevice(ua) {
  if (!ua) return { name: 'Desconocido', icon: Monitor };
  const s = ua.toLowerCase();
  if (s.includes('iphone') || (s.includes('android') && s.includes('mobile'))) return { name: 'Móvil', icon: Smartphone };
  if (s.includes('ipad') || s.includes('tablet')) return { name: 'Tablet', icon: Smartphone };
  if (s.includes('mac')) return { name: 'macOS', icon: Monitor };
  if (s.includes('windows')) return { name: 'Windows', icon: Monitor };
  if (s.includes('linux')) return { name: 'Linux', icon: Monitor };
  return { name: 'Escritorio', icon: Monitor };
}
function parseBrowser(ua) {
  if (!ua) return '';
  const s = ua.toLowerCase();
  if (s.includes('edg/')) return 'Edge';
  if (s.includes('chrome')) return 'Chrome';
  if (s.includes('firefox')) return 'Firefox';
  if (s.includes('safari')) return 'Safari';
  return '';
}

export default function LoginHistory() {
  const [logs, setLogs] = useState([]);
  const load = () => api.get('/login-history/mine').then(r => setLogs(r.data));
  useEffect(() => { load(); }, []);
  const removeOne = async (id) => {
    if (!window.confirm('¿Borrar este acceso del historial?')) return;
    try {
      await api.delete(`/login-history/${id}`);
      toast.success('Acceso eliminado del historial');
      load();
    } catch { toast.error('No se pudo eliminar'); }
  };
  const revokeAll = async () => {
    if (!window.confirm('Esto cerrará TODOS los dispositivos (incluido este). ¿Continuar?')) return;
    try {
      await api.post('/auth/revoke-all-sessions');
      toast.success('Cerramos todas las sesiones. Vuelve a iniciar sesión.');
      localStorage.removeItem('c4k_token');
      localStorage.removeItem('c4k_user');
      setTimeout(() => { window.location.href = '/login'; }, 800);
    } catch { toast.error('Error'); }
  };
  return (
    <div className="p-8 max-w-4xl mx-auto">
      <PageHeader
        title="Historial de accesos"
        subtitle="Tus últimos 20 inicios de sesión"
        right={logs.length > 0 && (
          <Button data-testid="revoke-all-btn" onClick={revokeAll} variant="outline" className="rounded-full text-rose-600 border-rose-200 hover:bg-rose-50">
            <ShieldOff className="w-4 h-4 mr-1"/> Cerrar todas las sesiones
          </Button>
        )}
      />
      {logs.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 p-12 text-center text-sm text-slate-500">Sin registros aún.</div>
      ) : (
        <div className="rounded-2xl bg-white border border-slate-200 divide-y">
          {logs.map(l => {
            const d = parseDevice(l.user_agent);
            const b = parseBrowser(l.user_agent);
            return (
              <div key={l.id} data-testid={`login-entry-${l.id}`} className="p-4 flex items-center gap-4">
                <div className="w-11 h-11 rounded-2xl bg-blue-100 text-blue-700 grid place-items-center">
                  <d.icon className="w-5 h-5"/>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold">{d.name}{b && ` · ${b}`}</div>
                  <div className="text-xs text-slate-500 inline-flex items-center gap-1 mt-0.5">
                    <MapPin className="w-3 h-3"/> {l.city || 'Desconocida'} · <span className="font-mono">{l.ip}</span>
                  </div>
                </div>
                <div className="text-xs font-mono text-slate-500 text-right">
                  {new Date(l.created_at).toLocaleString()}
                </div>
                <Button data-testid={`remove-login-${l.id}`} size="icon" variant="ghost" onClick={()=>removeOne(l.id)} className="text-rose-500 hover:bg-rose-50">
                  <Trash2 className="w-4 h-4"/>
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
